module.exports = __webpack_public_path__ + "static/media/energy-smart-zero-video-banner.23b75f20.jpg";